export default __webpack_public_path__ + "pgnv-assets/76febf8b40a90906f87f2ecf33a0a728.png";